export enum NewsLayout {
  Grid1x3 = 'Grid 1x3',
  GridXLine = 'xLine',
  CesarGrid = 'CesarGrid',
}
